import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCBoaris extends NPC {
    constructor() {
        super(definitions.NPC_ID.BOARIS);

        this.collisionRadius = 20;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_boaris_von_tusk_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(0, -6));
        this.animateIdle(0.8);
    }
}